function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.1809 8.18423C16.1809 7.61794 16.1315 7.06963 16.0371 6.54828H8.5V9.64491H12.8056C12.6213 10.6472 12.0551 11.4921 11.2101 12.0584V14.0674H13.7944C15.309 12.6696 16.1809 10.6202 16.1809 8.18423Z",
  fill: "#3E82F1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.49998 16C10.6618 16 12.473 15.2854 13.7944 14.0629L11.2101 12.0539C10.4955 12.5348 9.57863 12.818 8.49998 12.818C6.41459 12.818 4.65279 11.4112 4.02358 9.5191H1.34943V11.5955C2.66628 14.2067 5.3719 16 8.49998 16Z",
  fill: "#32A753"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.02359 9.51911C3.86179 9.03821 3.77191 8.52585 3.77191 8.00001C3.77191 7.47416 3.86179 6.9618 4.02359 6.48091V4.409H1.34944C0.810112 5.48765 0.5 6.71012 0.5 8.00001C0.5 9.28989 0.810112 10.5124 1.34944 11.591L4.02359 9.51911Z",
  fill: "#F9BB00"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.49998 3.18202C9.67302 3.18202 10.7292 3.58652 11.5562 4.37753L13.8528 2.0809C12.4685 0.791012 10.6573 0 8.49998 0C5.3719 0 2.66628 1.79326 1.34943 4.40899L4.02358 6.4809C4.65279 4.58877 6.41459 3.18202 8.49998 3.18202Z",
  fill: "#E74133"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.f04b23a3.svg";
export { ForwardRef as ReactComponent };